stimulusApp.register(
  "group-accommodation-filter",
  class extends Stimulus.Controller {
    static outlets = ["room-filter-option"]
    static targets = ["adjacency"]

    toggle(cardsLoaded) {
      if (!cardsLoaded) return

      this.element.classList.toggle(
        "hidden",
        this.roomFilterOptionOutlets.every((outlet) => outlet.disabled()),
      )

      const hideAdjacencies = this.roomFilterOptionOutlets
        .filter((outlet) => outlet.adjacency())
        .every((outlet) => outlet.disabled())
      this.adjacencyTargets.forEach((target) =>
        target.classList.toggle("hidden", hideAdjacencies),
      )
    }
  },
)
